export type WorkflowRequestMessages = {
  deleteWorkflowSuccess: string;
  deleteWorkflowError: string;
  activateWorkflowSuccess: string;
  activateWorkflowError: string;
  workflowNotFoundError: string;
  workflowNotFoundDescription: string;
  workflowNotFoundAlt: string;
  workflowErrorToLoad: string;
  deactivateStartFlowError: string;
};

export const WORKFLOW_REQUEST_MESSAGES: WorkflowRequestMessages = {
  // Success  Messages
  deleteWorkflowSuccess: "Agente excluído com sucesso.",
  deleteWorkflowError: "Erro ao excluir o agente.",
  activateWorkflowSuccess: "Status do agente alterado com sucesso",

  // Error Messages
  activateWorkflowError: "Erro ao alterar status do agente",
  workflowNotFoundError: "Agente não encontrado",
  workflowNotFoundDescription: "Não conseguimos encontrar o agente que você está procurando",
  workflowNotFoundAlt: "Agente não encontrado",
  workflowErrorToLoad: "Erro ao carregar o agente",
  deactivateStartFlowError:
    "Não é possível desativar um workflow de tipo 'Iniciar Fluxo' quando está ativo.",
};
